/* eslint-disable react/prop-types */
// External deps

import { Table, ContentCard } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

// Internal deps
import './NotificationReportTable.scss';

const reporteColumns = () => [
  {
    Header: 'SDS',
    accessor: 'nroSds',
    id: 'SDS',
    hideSort: true,
    style: {
      width: '10%'
    },
    Cell: ({ value }) => <span className="table-cell">{value}</span>
  },
  {
    Header: 'Pos',
    accessor: 'posicion',
    hideSort: true,
    style: {
      width: '5%'
    },
    Cell: ({ value }) => (
      <div className="poslin-cells">
        <span className="table-cell">{value}</span>
      </div>
    )
  },
  {
    Header: 'Línea',
    accessor: 'linea',
    hideSort: true,
    style: {
      width: '5%'
    },
    Cell: ({ value }) => (
      <div className="poslin-cells">
        <span className="table-cell">{value}</span>
      </div>
    )
  },
  {
    Header: 'Descripción posición',
    accessor: 'descripcionPosicion',
    hideSort: true,
    style: {
      width: '40%'
    },
    Cell: ({ value }) => <span className="table-cell">{value}</span>
  },
  {
    Header: 'Descripción servicio',
    accessor: 'descripcionServicio',
    hideSort: true,
    style: {
      width: '40%'
    },
    Cell: ({ value }) => <span className="table-cell">{value}</span>
  },
  {
    Header: 'U.M.R',
    accessor: 'umr',
    hideSort: true,
    style: {
      width: '10%'
    },
    Cell: ({ value }) => <span className="table-cell">{value}</span>
  },
  {
    Header: 'Cantidad reg.',
    accessor: 'cantidadReg',
    hideSort: true,
    style: {
      width: '10%'
    },
    Cell: ({ value }) => (
      <div className="number-cells">
        <span className="table-cell number-cells">{value}</span>
      </div>
    )
  },
  {
    Header: 'U.M.C',
    accessor: 'umc',
    hideSort: true,
    style: {
      width: '10%'
    },
    Cell: ({ value }) => <span className="table-cell">{value}</span>
  },
  {
    Header: 'Cantidad cert.',
    accessor: 'cantidadCert',
    hideSort: true,
    style: {
      width: '10%'
    },
    Cell: ({ value }) => (
      <div className="number-cells">
        <span className="table-cell number-cells">{value}</span>
      </div>
    )
  },
  {
    Header: 'Cert. precio',
    accessor: 'certPrecio',
    hideSort: true,
    style: {
      width: '10%'
    },
    Cell: ({ value }) => (
      <div className="number-cells">
        <span className="table-cell number-cells">{value}</span>
      </div>
    )
  },
  {
    Header: 'Subtotal',
    accessor: 'subTotalStr',
    hideSort: true,
    style: {
      width: '10%'
    },
    Cell: ({ value }) => (
      <div className="number-cells">
        <span className="table-cell number-cells">{value}</span>
      </div>
    )
  }
];

const NotificationReportTable = ({ data }) => (
  <>
    <ContentCard className="mb-5" mark="none" orientation="vertical">
      <h6 className="table-title">Resumen de costos</h6>

      {data?.resumenDeCostos?.map((element, index) => (
        <div key={element.dm}>
          <Table columns={reporteColumns()} data={element.resumenDeCostos} titleLeft type="light" />
          <div className="table-subrow">
            <h6 className="table-subrow-txt">
              <span style={{ marginRight: '10px' }}>
                Total{' '}
                {data.resumenDeCostos[index].dm === 'SinDm'
                  ? 'sin DM'
                  : data.resumenDeCostos[index].dm}
                :
              </span>
              <span style={{ marginRight: '5px' }}>{data.moneda}</span>
              <span>{data.resumenDeCostos[index].total}</span>
            </h6>
          </div>
        </div>
      ))}
    </ContentCard>
  </>
);

NotificationReportTable.propTypes = {
  data: PropTypes.shape({
    moneda: PropTypes.string,
    resumenDeCostos: PropTypes.shape([])
  })
};
NotificationReportTable.defaultProps = {
  data: {}
};

export default NotificationReportTable;
